import Landing from './components/page/Landing'
import PromoExamples from './components/page/PromoExamples'
import Search  from './components/page/Search'
import Owner  from './components/page/Owner'
import Configure  from './components/page/Configure'
import AddOns  from './components/page/AddOns'
import Items  from './components/page/Items'
import Review  from './components/page/Review'
import Thanks  from './components/page/Thanks'
import Missing from './components/page/Missing'
import CancelPayment from './components/page/CancelPayment'

/**
 * Supply route params as objects rather than json
 * @param  {Object} paramNames Object with the structure {paramName : defaultValue}
 * @return {Function}         A function that parses params as defined on the route, with certain fields parsed
 */
function parseRouteParams(paramsObject) {
	// Find specific paramNames in `route.params` and overwrite them with the parsed version
	return function (route) {
		Object.keys(paramsObject).forEach(paramName => {
			let defaultValue = paramsObject[paramName]

			if (typeof route.params[paramName] === 'string') {
				route.params[paramName] = JSON.parse(route.params[paramName])
			} else if(typeof route.params[paramName] === 'undefined') {
				route.params[paramName] = defaultValue
			}
		})

		return route.params
	}
}

export default [
	{ path : '/', component : Landing },
	{ path : '/examples', component : PromoExamples },
	{ name : 'search', path : '/search/:basket?', component : Search, props : parseRouteParams({'basket' : {}}) },
	{ name : 'owner', path : '/select/:ownerType/:ownerId/:basket?', component : Owner, props : parseRouteParams({'basket' : {}}) },
	{ name : 'items', path : '/items/:basket?', component : Items, props : parseRouteParams({'basket' : {}}) },
	{ name : 'configure', path : '/configure/:basket', component : Configure, props : parseRouteParams({'basket' : {}}) },
	{ name : 'bonus-buttons', path : '/bonus-buttons/:basket', component : AddOns, props : parseRouteParams({'basket' : {}}) },
	{ name : 'review', path : '/review/:basket', component : Review, props : parseRouteParams({'basket' : {}}) },
	{ path : '/thanks', component : Thanks, props : true },
	{ path : '/cancel', component : CancelPayment, props : true },
	{ path : '/404', component: Missing },
	{ path : '*', redirect: '/404' }
]
